<!-- <a class="chatbox-btn toggle-bookmark fa fa-bookmark
   {[ if (o.bookmarked) {]} button-on {[ } ]}" title="{{{o.info_toggle_bookmark}}}"></a> -->
